import "core-js/modules/es.function.name.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import getPictureUrl from 'utils/image/getPictureUrl';
import Box from 'components/Box';
import PageSection from 'components/PageSection';
import TopicCard from 'components/TopicCard';
import { RECOMMENDED_TOPIC_THUMBNAIL_SIZE } from 'screens/ThumbnailPreview';
import Wrapper from '../common/Wrapper';
import { jsx as _jsx } from "react/jsx-runtime";
export function TopicThumbnailPreview(props) {
  var _props$data = props.data,
    thumbnailId = _props$data.thumbnailId,
    name = _props$data.name,
    onClose = props.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsx(Wrapper, {
    id: "preview-topic-modal",
    title: t('thumbnail_preview_item_image_preview', {
      itemName: t('content_type_topic')
    }),
    aspectRatio: "8:5",
    recommendedSize: RECOMMENDED_TOPIC_THUMBNAIL_SIZE,
    onClose: onClose,
    children: /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(Box, {
        width: 165,
        children: /*#__PURE__*/_jsx(TopicCard, {
          icon: "topic",
          imageSrc: getPictureUrl({
            id: thumbnailId,
            dimensions: 'w_165,h_103'
          }),
          children: name
        })
      })
    })
  });
}
export default TopicThumbnailPreview;